module.exports = __webpack_public_path__ + "static/img/logo-1.849b83a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-1.png
// module id = Ng0a
// module chunks = 1